import Box from '../Box'
import styles from './SalesCard.module.scss'

const CardRow = ({ title, value, unassignedText = 'Unassigned', optional, onEdit }) => {
  const textColorClass = value
    ? styles.value
    : optional
    ? styles.value
    : styles.unassigned

  return (
    <div className={styles.row}>
      <div className={styles.rowContent}>
        <p className={styles.title}>{title}</p>
        <p className={textColorClass}>{value || unassignedText}</p>
      </div>
      {onEdit && (
        <button className={styles.editButton} onClick={onEdit}>
          Edit
        </button>
      )}
    </div>
  )
}

const SalesCard = ({ customerSuccessManager, salesPerson, referrer, csmNote, onEditClick }) => {
  return (
    <Box
      cornerButtonText="Edit"
      hasCornerButton={!!onEditClick}
      onClickCornerButton={onEditClick}
    >
      <CardRow title="CSM" value={customerSuccessManager} />
      {csmNote && (
        <div className={styles.noteDisplay}>
          <p className={styles.noteLabel}>CSM Notes:</p>
          <p className={styles.noteText}>{csmNote}</p>
        </div>
      )}
      <CardRow title="Sales agent" value={salesPerson} />
      <CardRow title="Referrer" value={referrer} unassignedText="None" optional={true} />
    </Box>
  )
}

export default SalesCard
